/* Lupa sobre un lienzo · Imprimirlo
 *
 * El dibujo de la prenda sale pequeño —tiene que caber al lado del
 * configurador— y ahí no se ven los detalles del logo. Ampliar el lienzo no
 * vale: se vería el mismo dibujo borroso, porque lo que falta son píxeles.
 *
 * Así que la lupa NO amplía la imagen: pide que se vuelva a DIBUJAR el mismo
 * contenido en grande y enseña un trozo de ese dibujo grande. Como todo se
 * pinta con canvas a partir del archivo original, el detalle está de verdad.
 *
 *   Lupa.enganchar(lienzo, hacerGrande, { zoom, tam })
 *
 *     lienzo       el canvas pequeño que ve el cliente
 *     hacerGrande  función que devuelve un canvas del MISMO contenido, más
 *                  grande. Se llama una sola vez, la primera que se acerca el
 *                  ratón: si nadie mira de cerca, no se gasta nada.
 *
 * Los estilos van aquí dentro a propósito. Esto tiene que poder engancharse
 * desde cualquier ficha —ropa, DTF, packs— y cada una tiene su hoja de
 * estilos; si dependiera de una, en las demás saldría rota.
 */
(function () {
  'use strict';

  var caja = null, dentro = null;

  function crear() {
    if (caja) return caja;
    caja = document.createElement('div');
    caja.setAttribute('aria-hidden', 'true');
    caja.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;display:none;' +
      'border-radius:12px;overflow:hidden;background:#fff;' +
      'box-shadow:0 6px 28px rgba(0,0,0,.28);border:2px solid rgba(255,255,255,.9);' +
      'outline:1px solid rgba(0,0,0,.18)';
    dentro = document.createElement('canvas');
    dentro.style.display = 'block';
    caja.appendChild(dentro);
    document.body.appendChild(caja);
    return caja;
  }

  function esconder() { if (caja) caja.style.display = 'none'; }

  function enganchar(lienzo, hacerGrande, op) {
    if (!lienzo || lienzo._lupa) { if (lienzo) lienzo._lupa.hacer = hacerGrande; return; }
    op = op || {};
    var tam = op.tam || 190, zoom = op.zoom || 3;
    var estado = { hacer: hacerGrande, grande: null };
    lienzo._lupa = estado;
    lienzo.style.cursor = 'zoom-in';

    function mover(e) {
      if (!estado.grande) {
        try { estado.grande = estado.hacer(); } catch (err) { estado.grande = null; }
        if (!estado.grande) return;
      }
      var g = estado.grande;
      var r = lienzo.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
      if (fx < 0 || fx > 1 || fy < 0 || fy > 1) return esconder();

      var c = crear();
      var dpr = window.devicePixelRatio || 1;
      if (dentro.width !== Math.round(tam * dpr)) {
        dentro.width = Math.round(tam * dpr);
        dentro.height = Math.round(tam * dpr);
        dentro.style.width = tam + 'px';
        dentro.style.height = tam + 'px';
      }
      /* Cuántos píxeles del dibujo grande caben en la lupa: los que haya que
         coger para que se vean "zoom" veces más grandes que en el pequeño. */
      var escala = g.width / r.width;
      var lado = tam * escala / zoom;
      var sx = fx * g.width - lado / 2, sy = fy * g.height - lado / 2;
      var x = dentro.getContext('2d');
      x.setTransform(dpr, 0, 0, dpr, 0, 0);
      x.clearRect(0, 0, tam, tam);
      x.fillStyle = '#ffffff';
      x.fillRect(0, 0, tam, tam);
      x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
      x.drawImage(g, sx, sy, lado, lado, 0, 0, tam, tam);

      // pegada al cursor pero sin salirse de la pantalla ni taparlo
      var px = e.clientX + 24, py = e.clientY - tam - 24;
      if (px + tam + 8 > window.innerWidth) px = e.clientX - tam - 24;
      if (py < 8) py = e.clientY + 24;
      c.style.left = Math.max(8, px) + 'px';
      c.style.top = Math.max(8, py) + 'px';
      c.style.display = 'block';
    }

    lienzo.addEventListener('pointermove', mover);
    lienzo.addEventListener('pointerleave', esconder);
    /* En el móvil no hay "pasar por encima": se mira manteniendo el dedo. Se
       corta el scroll solo mientras se está mirando. */
    lienzo.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') { e.preventDefault(); mover(e); }
    });
    lienzo.addEventListener('pointerup', esconder);
    lienzo.addEventListener('pointercancel', esconder);
    window.addEventListener('scroll', esconder, { passive: true });
  }

  window.Lupa = { enganchar: enganchar, esconder: esconder };
})();